// extracted by css-extract-rspack-plugin
export default {"container":"c2INngk___container","vacancies-chart":"kMT3TdW___vacancies-chart","vacanciesChart":"kMT3TdW___vacancies-chart"};